import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import CompanyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import { ICreateBusinessPartnerContact } from './interfaces/create-business-partner-contact.interface';
import BusinessPartnerContactAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-contact/business-partners-contact.entity';
import { SalesOfficeService } from 'app/modules/components/configuration/sales-office/sales-office.service';
import { RouteAreaService } from 'app/modules/components/routing/route-area/route-area.service';
import { SubRouteService } from 'app/modules/components/routing/sub-routes/sub-route.service';
import { BusinessPartnerContactFunctionAttributes, SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import RouteAreaAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BusinessPartnerContactFunctionService } from '../business-partner-contact-function-modal/business-partner-contact-function.service';
import { HandlerMessageService } from 'app/common/services/handler-error/handler-message.service';


@Component({
  selector: 'app-add-business-partner-contact-modal',
  styleUrl: './business-partner-contact.component.scss',
  templateUrl: './business-partner-contact.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
  ],
})
export class AddBusinessPartnerContactComponent {
  currentCreateBusinessPartnerContact: ICreateBusinessPartnerContact = this.initializeCreateBusinessPartnerContact();
  currentUpdateBusinessPartnerContact: BusinessPartnerContactAttributes | undefined;

  selectedDivisionIds: string[] = [];


  companyList : CompanyAttributes[] = [];
  routeAreaList: RouteAreaAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  subRutaList: SubRouteAttributes[] = [];
  functionList: BusinessPartnerContactFunctionAttributes[]= [];


  
  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<SubRouteAttributes[]> = new FormControl<
    SubRouteAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<SubRouteAttributes[]> = new ReplaySubject<
    SubRouteAttributes[]
  >(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: SubRouteAttributes[] = [];


  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  
 isEditMode : boolean;
 protected _onDestroy = new Subject<void>();
  constructor(
    private readonly companyService: CompanyService,
    private readonly routeService: RouteAreaService,
    private readonly subrouteService: SubRouteService,
    private readonly salesOfficeService: SalesOfficeService,
    private contactFunctionService: BusinessPartnerContactFunctionService,
    public dialogRef: MatDialogRef<AddBusinessPartnerContactComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Optional: if you want to pass data
    private readonly handlerMessage: HandlerMessageService
  ) {
    this.isEditMode = !!data; 
    if (this.isEditMode) {
      this.currentCreateBusinessPartnerContact = { 
        ...data,
        routingSalesOfficeId: data.routingSalesOffice?._id.toString(),
        contact: {
          ...data.contact,
          firstName: data.contact?.firstName,
          lastName: data.contact.lastName?data.contact.lastName:'',
          fullName: data.contact.fullName?data.contact.fullName:'',
          functionId: data.contact.function ? data.contact.function._id.toString() : null,
        },  
        subRouteIds: data.subRoutes?.map((subRouteId) => subRouteId._id.toString()),
        routeAreaId: data.routeArea?._id,
        companyId: data.company?._id,
    }; 
    }
  }

  
  ngAfterViewInit(): void {
    // this.setupPaginationAndSorting();
    this.fetchAllCompanies();
    this.fetchAllContactFunction();
    this.fetchAllSalesOffice();
    this.fetchAllRouteArea();
    this.fetchAllSubRoutes();

    // this.findAllWithCount();
  }
  private fetchAllContactFunction(): void {
    this.contactFunctionService.findToComboBox().subscribe({
      next: (res) => {
        this.functionList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener función",
          statusCode: err.status
        });
      },
    });
  }
  
  updateFullName() {
    this.currentCreateBusinessPartnerContact.contact.fullName = `${this.currentCreateBusinessPartnerContact.contact.firstName} ${this.currentCreateBusinessPartnerContact.contact.lastName || ''}`;
  }
  

  private fetchAllSalesOffice(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener oficina de ventas",
          statusCode: err.status
        });
      }
    });
  }

  private fetchAllRouteArea(): void {
    this.routeService.findToComboBox().subscribe({
      next: (res) => {
        this.routeAreaList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener área de ruta",
          statusCode: err.status
        });
      }
    });
  }

  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener compañías",
          statusCode: err.status
        });
      }
    });
  }

  private fetchAllSubRoutes(): void {
    this.subrouteService.findToComboBox().subscribe({
      next: (res) => {
        this.subRutaList = res.data;
        this.filteredRoutes.next(this.subRutaList);
        this.filteredRoutes.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentCreateBusinessPartnerContact.subRouteIds
              .includes(material._id.toString())
          );
          this.routeMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMulti();
            this.setToggleAllCheckboxState();
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener sub rutas",
          statusCode: err.status
        });
      }
    });
  }

  protected filterRouteMulti() {
    if (!this.subRutaList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.subRutaList;
      this.filteredRoutes.next(this.subRutaList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteCache = this.subRutaList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  
//   private fetchAllContactFunction(): void {
//     this.functionService.findToComboBox().subscribe({
//       next: (res) => {
//         this.functionList= res.data;
//       },
//       error: (err) => {
//       }
//     });
//   }



  private initializeCreateBusinessPartnerContact(): ICreateBusinessPartnerContact {
    return {
        routingSalesOfficeId: '',
        subRouteIds: [],
        companyId: '',
        routeAreaId: '',
        contact: {
            functionId: '',
            fullName: '',
            firstName: '',
            lastName: '',
            isPrincipal: false
        }
    };

  }

  save() {
    this.currentCreateBusinessPartnerContact.subRouteIds = this.routeMultiCtrl.value.map((subRoute: SubRouteAttributes) =>
      subRoute._id.toString()
    ),
    this.dialogRef.close(this.currentCreateBusinessPartnerContact);
  }
}
